/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button } from "antd-mobile";
import { FormattedMessage, injectIntl } from "react-intl";
import { intl } from "../../services/intlGlobalProvider";
import QrReader from "react-qr-reader";
import styled from "styled-components";
import * as _ from "underscore";
import { getUrlQueryParams } from "../../utils/UrlManager";
import Toast from "../../utils/Toast";
import Theme from "../../utils/Theme";
import "./index.css";

const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  background: black;
`;

const StyledScannerContainer = styled.div`
  width: 100%;
  height: 100%;
  color: lightgray;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledPlaceholderContainer = styled.div`
  width: 100%;
  height: 100%;
  color: grey;
  background: lightgray;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledPlaceholderTitle = styled.span`
  font-weight: bold;
  font-size: 1.2em;
`;

const StyledPlaceholderImgContainer = styled.div`
  margin-top: 40px;
  background: white;
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px;
`;

const StyledPlaceholderImg = styled.img`
  width: 90%;
  height: auto;
`;

const StyledLegacyButton = styled(Button)`
  margin-top: 20px;
  && {
    border-radius: 25px;
    font-size: 1em;
    width: 60%;
    background: ${Theme.PrimaryColor};
    color: white;
  }
`;

class ScannerPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
      legacyMode: false,
      animationClass: null
    };
  }

  componentDidMount() {
    const { navbarConfig, history, showTabbar, showNavbar } = this.props;

    window.iOS = ["iPad", "iPhone", "iPod"].indexOf(navigator.platform) >= 0;
    window.isMediaStreamAPISupported =
      navigator &&
      navigator.mediaDevices &&
      "enumerateDevices" in navigator.mediaDevices;
    window.noCameraPermission = false;

    if (navigator.getUserMedia) {
      navigator.getUserMedia(
        { video: true },
        localMediaStream => {},
        error => this.setState({ legacyMode: true })
      );
    } else {
      this.setState({ legacyMode: true });
      // console.log("Sorry, browser does not support camera access");
    }

    navbarConfig(
      <FormattedMessage
        id="scanner.title"
        defaultMessage="Scan QR Code"
        description="Scan QR Code Title"
      />,
      null,
      null,
      () => this.onBackPressed(),
      null
    );
    showNavbar(true);
    showTabbar(false);
    this.setState({ animationClass: "slide-in-right" });
  }

  onBackPressed = () => {
    const { history } = this.props;
    this.setState({ animationClass: "slide-out-right" });

    window.setTimeout(() => {
      history.goBack();
    }, 300);
  };

  onSubmitResult = result => {
    const { location, history } = this.props;
    const returnUrl =
      location && location.state && location.state.returnUrl
        ? location.state.returnUrl
        : null;

    if (returnUrl) {
      const queryParams = getUrlQueryParams(result);
      const targetParam = queryParams.find(
        queryParam => queryParam.key === "table_code"
      );
      const value = !_.isEmpty(targetParam) ? targetParam.value : null;

      if (_.isEmpty(value)) {
        Toast.error(intl.formatMessage({ id: "scanner.scan.invalid.qrcode" }));
        return;
      }
      history.push({
        pathname: returnUrl,
        state: { qrcodeValue: value }
      });
    }
  };

  render() {
    const { ready, animationClass, legacyMode } = this.state;

    return (
      <StyledContainer
        className={animationClass !== null ? animationClass : false}
        onAnimationEnd={() =>
          this.setState({ animationClass: null, ready: true })
        }
      >
        {ready ? (
          <StyledScannerContainer>
            <span>
              {legacyMode ? (
                <FormattedMessage
                  id="scanner.scan.camera.error"
                  defaultMessage="Video Camera can't be access and opened"
                  description="Scanning QR Code permissions issues"
                />
              ) : (
                <FormattedMessage
                  id="scanner.scan.placeholder"
                  defaultMessage="Scanning QR Code"
                  description="Scanning QR Code Placeholder"
                />
              )}
            </span>
            <QrReader
              ref={scanner => {
                this.scanner = scanner;
              }}
              onError={err => console.log(err)}
              onScan={data => data && this.onSubmitResult(data)}
              style={{
                width: "85%",
                border: "3px solid aquamarine",
                marginTop: "30px",
                background: "grey"
              }}
              legacyMode={legacyMode}
              showViewFinder={false}
              resolution={1800}
            />
            {legacyMode ? (
              <StyledLegacyButton
                onClick={() => this.scanner.openImageDialog()}
                activeStyle={{ backgroundColor: Theme.ActivePrimary }}
              >
                <FormattedMessage
                  id="scanner.scan.select.image"
                  defaultMessage="Select Image"
                  description="Scanning by select image"
                />
              </StyledLegacyButton>
            ) : null}
          </StyledScannerContainer>
        ) : (
          <StyledPlaceholderContainer>
            <StyledPlaceholderTitle>
              <FormattedMessage
                id="scanner.placeholder"
                defaultMessage="Scan the QR code on the table."
                description="Scanner Placeholder Title"
              />
            </StyledPlaceholderTitle>
            <StyledPlaceholderImgContainer>
              <StyledPlaceholderImg
                src={require("../../assets/qr_code_placeholder.png")}
                alt="QR Code Placeholder"
              />
            </StyledPlaceholderImgContainer>
          </StyledPlaceholderContainer>
        )}
      </StyledContainer>
    );
  }
}

ScannerPage.propTypes = {
  intl: PropTypes.object,
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};
export default injectIntl(ScannerPage);



// WEBPACK FOOTER //
// ./src/containers/ScannerPage/index.js